/* eslint-disable react/jsx-fragments */
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import DropdownToggle from "reactstrap/lib/DropdownToggle";
import Button from "reactstrap/lib/Button";

import Icon from "../icon/icon";

const DropdownTrigger = props => {
  const {
    type,
    disabled,
    disabledTrigger,
    label,
    split,
    disabledMain,
    onClick,
    icon,
    ariaLabel
  } = props;
  if (type === "tertiary" || type === "link") {
    return (
      <DropdownToggle
        caret
        className={`oui-dt-type-${type}`}
        disabled={disabled || disabledTrigger}
      >
        {label}&nbsp;
      </DropdownToggle>
    );
  }

  if (type === "icon" && React.isValidElement(icon)) {
    return (
      <DropdownToggle tag="span" disabled={disabled || disabledMain}>
        {React.cloneElement(icon, {
          clickable: true,
          disabled: disabled || disabledTrigger
        })}
      </DropdownToggle>
    );
  }

  return split ? (
    <Fragment>
      <Button
        color="primary"
        outline={type === "secondary"}
        onClick={onClick}
        disabled={disabled || disabledMain}
      >
        {label}
      </Button>
      <DropdownToggle
        caret
        color="primary"
        outline={type === "secondary"}
        split={split}
        disabled={disabled || disabledTrigger}
      />
    </Fragment>
  ) : (
    <Fragment>
      {icon ? (
        <DropdownToggle
          tag="div"
          className="oui-icon-dropdown-trigger"
          disabled={disabled || disabledMain}
        >
          <Button
            color="primary"
            outline={type === "secondary"}
            aria-label={ariaLabel ? `${ariaLabel} dropdown` : ""}
            onClick={onClick}
            disabled={disabled || disabledMain}
          >
            {React.isValidElement(icon) ? (
              icon
            ) : (
              <Icon muted={false} {...icon} />
            )}
          </Button>
        </DropdownToggle>
      ) : (
        <DropdownToggle
          caret
          color="primary"
          outline={type === "secondary"}
          disabled={disabled || disabledTrigger}
        >
          {label}&nbsp;
        </DropdownToggle>
      )}
    </Fragment>
  );
};

DropdownTrigger.propTypes = {
  type: PropTypes.string,
  disabled: PropTypes.bool,
  disabledTrigger: PropTypes.bool,
  disabledMain: PropTypes.bool,
  label: PropTypes.string,
  split: PropTypes.bool,
  icon: PropTypes.shape({
    src: PropTypes.string,
    size: PropTypes.oneOf(["xs", "sm", "md", "lg"]),
    width: PropTypes.string,
    height: PropTypes.string,
    classes: PropTypes.string,
    onClick: PropTypes.func
  }),
  onClick: PropTypes.func,
  ariaLabel: PropTypes.string
};

DropdownTrigger.defaultProps = {
  type: "primary",
  disabled: false,
  disabledTrigger: false,
  disabledMain: false,
  label: null,
  split: false,
  icon: null,
  onClick: null
};

DropdownTrigger.displayName = "OrionDropdownTrigger";

export default DropdownTrigger;
